import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Class representing the FilterReportHashView.
 * Extends JetView to create a custom view for filtering report hashes.
 */
export default class FilterReportHashView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Left section containing input fields for date and platform selection
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'ModificationDate', // Field for modification date
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Modificación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'text',
                            name: 'LastDetectionDate', // Field for last detection date
                            id: 'Datepicker',
                            css: 'reportrange',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha ultima detección'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'richselect',
                            name: 'Platform', // Dropdown for platform selection
                            label: _('Plataforma'),
                            labelPosition: 'top',
                            placeholder: _('Plataforma'),
                            value: '',
                            options: [{ id: '0', value: _('Backend') }], // Options for platform
                        },
                    ],
                },
            ],
        };

        // Upper section containing the left input fields
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 360 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };

        // Button section with actions for clearing and consulting
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Placeholder for layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            hotkey: 'enter', // Shortcut key for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('reportHash:filter', [filterdata]); // Trigger filter event
                            },
                        },
                    ],
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form',
            rows: [upper_section, buttons],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up any necessary event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
